import React from "react";
import { Modal } from "react-bootstrap";

import PoRevisionPrintTemplate
    from "./PoRevisionPrintTemplate";

const PoRevisionPrintModal = ({
    show,
    onHide,
    printHistory
}) => {
    return (
        <Modal
            show={show}
            onHide={onHide}
            fullscreen
            backdrop="static"
            keyboard
            enforceFocus={false}
        >
            <Modal.Header closeButton>
                <Modal.Title>
                    Purchase Order Print
                    {" - "}
                    {printHistory?.poNumber || "N/A"}
                </Modal.Title>
            </Modal.Header>

            <Modal.Body
                style={{
                    padding: 0,
                }}
            >
                <PoRevisionPrintTemplate
                    printHistory={printHistory}
                />
            </Modal.Body>
        </Modal>
    );
};

export default PoRevisionPrintModal;